export default __webpack_public_path__ + "static/media/hht2_storybook_09.1cf495ea.png";